import * as z from "zod";
import { mutator } from "./mutator";

export const deleteOAuthApp = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {},
  permissions: {
    none: "compatibility no-op for the retired OAuth app registry",
  },
  fn: () => Promise.resolve(),
});
